import { render, staticRenderFns } from "./PanelCompetitionLanguages.vue?vue&type=template&id=045a0256&scoped=true&"
import script from "./PanelCompetitionLanguages.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionLanguages.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionLanguages.vue?vue&type=style&index=0&id=045a0256&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a0256",
  null
  
)

export default component.exports